"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMediaVideo = void 0;
const react_1 = __importStar(require("react"));
const react_player_1 = __importDefault(require("react-player"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_media_styles_1 = require("./fdr-media.styles");
const ASPECT_RATIO = 9 / 16;
function FdrMediaVideo(props) {
    const { className, active, playing = active, preview, lazy, controls, muted, interactive, resource, onPlay, onEnded, loop, fullScreen, previewImage, } = props;
    const [started, setStarted] = (0, react_1.useState)(false);
    const wrapperRef = (0, react_1.useRef)(null);
    const tempStyle = (0, react_1.useRef)(null);
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        if (!fullScreen)
            return;
        const wrapper = wrapperRef.current;
        const player = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(`.react-player`);
        if (!wrapper || !player)
            return;
        const portHeight = window.innerHeight;
        const portWidth = window.innerWidth;
        const wrapperHeight = wrapper.getBoundingClientRect().height;
        const wrapperWidth = wrapper.getBoundingClientRect().width;
        const playerWidth = (wrapperWidth * portHeight) / wrapperHeight;
        const playerHeight = (wrapperHeight * portWidth) / wrapperWidth;
        const isPlayerWidthSmaller = portWidth > playerWidth;
        const isPlayerHeightSmaller = portHeight > playerHeight;
        const transformY = isPlayerHeightSmaller
            ? 0
            : (playerHeight - portHeight) / 2;
        const style = `
      height: ${wrapperHeight > portHeight ? wrapperHeight : portHeight}px;
      width: ${isPlayerWidthSmaller ? wrapperWidth : playerWidth}px;
      margin-left: ${isPlayerWidthSmaller ? 'initial' : `-${(playerWidth - portWidth) / 2}px`};
      transform: ${isPlayerHeightSmaller ? 'initial' : `translateY(-${transformY}px)`};

      `;
        if (style === tempStyle.current)
            return;
        tempStyle.current = style;
        player.setAttribute(`style`, style);
    });
    const PreviewImage = previewImage ? previewImage : fdr_media_styles_1.DefaultPreviewImage;
    const getStarted = () => {
        setStarted(true);
    };
    return (react_1.default.createElement(fdr_media_styles_1.MediaVideoWrapper, { fullScreen: fullScreen, className: className, "data-testid": "video-media" },
        !started && react_1.default.createElement(PreviewImage, { image: preview, lazy: lazy }),
        react_1.default.createElement(fdr_media_styles_1.PlayerWrapper, { aspectRatio: ASPECT_RATIO, fullScreen: fullScreen, ref: wrapperRef, style: {
                pointerEvents: interactive ? 'all' : 'none',
            } },
            react_1.default.createElement(react_player_1.default, { url: resource, playing: active && playing, muted: muted, width: "100%", height: "100%", onPlay: onPlay, onEnded: onEnded, onBuffer: getStarted, onProgress: getStarted, onBufferEnd: getStarted, controls: controls, volume: 0.3, loop: loop, className: "react-player" }))));
}
exports.FdrMediaVideo = FdrMediaVideo;
//# sourceMappingURL=fdr-media-video.js.map